/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Traces_Pagination_NextInputs */

const es_admin_traces_pagination_next = /** @type {(inputs: Admin_Traces_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siguiente`)
};

const en_admin_traces_pagination_next = /** @type {(inputs: Admin_Traces_Pagination_NextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Next`)
};

/**
* | output |
* | --- |
* | "Next" |
*
* @param {Admin_Traces_Pagination_NextInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_traces_pagination_next = /** @type {((inputs?: Admin_Traces_Pagination_NextInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Traces_Pagination_NextInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_traces_pagination_next(inputs)
	return en_admin_traces_pagination_next(inputs)
});
export { admin_traces_pagination_next as "admin.traces.pagination.next" }